import {configureStore} from '@reduxjs/toolkit'

import userSlice from './system/user/userSlice'
import roleSlice from './system/role/roleSlice'
import passwordSlice from './password/passwordSlice'
import campusSlice from './system/campus/campusSlice'
import generalSlice from './general/generalSlice'
import kankorSlice from './dua/kankor/kankorSlice'
import academicSlice from './dua/academic/academicSlice'
import positionSlice from './dua/hr/positionSilce'
import schoolSlice from './system/school/schoolSlice'
import studentSlice from './dua/student/studentSlice'
import toolsSlice from './system/tools/toolsSlice'
import OrganizationSlice from './dua/hr/organizationSlice'
import studentInvoiceSlice from './dua/finance/studentInvoiceSlice'
import attendanceSlice from './dua/hr/attendanceSlice'
import classRoomSlice from './dphs/classRoom/classRoomSlice'
import studentAttendanceSlice from './dua/student/studentAttendanceSlice'
import studentScoreSlice from './dua/student/studentScoreSlice'
import schoolStudentSlice from './dphs/student/schoolStudentSlice'
import itemSlice from './canteen/itemSlice'
import purchaseSlice from './canteen/purchaseSlice'
import saleSlice from './canteen/saleSlice'
import lecturerPortalSlice from './dua/lecturer-portal/lecturerPortalSlice'
import dashboardSlice from './canteen/dashboardSlice'
import StudentPortalSlice from './dua/student-portal/StudentPortalSlice'
import staffSlice from './dua/hr/staffSlice'
import lecturerSlice from './dua/hr/lecturerSlice'
import financeCategorySlice from './system/finance-category/financeCategorySlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    role: roleSlice,
    passwordSlice: passwordSlice,
    campus: campusSlice,
    general: generalSlice,
    kankor: kankorSlice,
    academic: academicSlice,
    staff: staffSlice,
    position: positionSlice,
    school: schoolSlice,
    student: studentSlice,
    tools: toolsSlice,
    organization: OrganizationSlice,
    studentInvoice: studentInvoiceSlice,
    attendance: attendanceSlice,
    classRoom: classRoomSlice,
    studentAttendance: studentAttendanceSlice,
    studentScore: studentScoreSlice,
    schoolStudent: schoolStudentSlice,
    item: itemSlice,
    purchase: purchaseSlice,
    sale: saleSlice,
    lecturerPortal: lecturerPortalSlice,
    canteenDashboard: dashboardSlice,
    studentPortal: StudentPortalSlice,
    lecturer: lecturerSlice,
    financeCategory: financeCategorySlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
